import React from 'react';
import Page from './Page';
import {FancyButton, Icon} from '../widgets';
import FancyLink from '../widgets/FancyLink';
import {connect} from 'react-redux';
import {uiActions} from '../chrome';
import './SchoolsPage.css';
import QuoteCard from '../widgets/QuoteCard';

const FaithPage = ({signup}) => {
	return (
		<Page className="SchoolsPage fullwidth" title="B2Me for faith communities">
			<section>
				<h1>Building community engagement</h1>
				<h2>through an online business directory</h2>
			</section>
			<div className="SchoolsPage-feature row">
				<QuoteCard
					disc={<Icon name="school" />}
					title="For faith communities"
					content="Identify and support small to medium sized business owners within your faith community and the community at large."
				/>
				<QuoteCard
					disc={<Icon name="account_box" />}
					title="For service providers"
					content="List your business for free within your faith community, and do business with people who have similar values and interests."
				/>
				<QuoteCard
					disc={<Icon name="search" />}
					title="For service seekers"
					content="Support your faith community by engaging service providers who you know and trust."
				/>
			</div>
			<section>
				<h2>Enjoy these benefits when your faith community partners with B2Me:</h2>
				<ul>
					<li>
						Easily identify, connect, and engage with service providers from within your faith
						community
					</li>
					<li>Gain visibility and build engagement with others in the broader community</li>
					<li>
						Communicate easily with service providers who can add value to your faith community
					</li>
					<li>Free access to the marketplace for service providers and service seekers</li>
				</ul>
			</section>
			<section>
				<div style={{display: 'flex', justifyContent: 'center'}}>
					<FancyLink
						className="calltoaction"
						href="https://share.hsforms.com/1IpKFZ73dRjyHzG9ZGQkoPw2gqzs">
						Request a demo
					</FancyLink>
					<FancyButton className="emphasis calltoaction" onClick={signup}>
						Get started
					</FancyButton>
				</div>
			</section>
			<div className="SchoolsPage-feature row">
				<QuoteCard
					disc={<img src="img/rob.jpg" alt="Ps Rob Furlong" />}
					content={[
						<blockquote key="1">
							"There are few access points into the community and we want to show we're not
							isolated, but care about the community."
						</blockquote>,
						<cite key="2">Ps Rob Furlong (Senior Pastor), Woodvale Baptist Church, Perth</cite>
					]}
				/>
				<QuoteCard
					disc={<img src="img/albert.jpg" alt="Hon. Albert Jacob" />}
					content={[
						<blockquote key="1">
							"Joondalup is an incredibly diverse community and one which has always welcomed people
							from all backgrounds and walks of life. B2Me offers a chance to not only strengthen
							existing networks but also to open up opportunities to new networks of people who
							share this community with us."
						</blockquote>,
						<cite key="2">Hon. Albert Jacob, Major, City of Joondalup</cite>
					]}
				/>
				<QuoteCard
					disc={<img src="img/bec.jpg" alt="Bec Chang" />}
					content={[
						<blockquote key="1">
							"B2Me is a great platform to share my business with the wider community. I love the
							fact that I can add businesses I support and have used to to my own collections, so
							clients can see who I trust for services."
						</blockquote>,
						<cite key="2">Bec Chang, Bec Chang Creative</cite>
					]}
				/>
			</div>
			<section className="lefty">
				<h2>Why should we join B2Me?</h2>
				<p>
					B2Me is grounded in a strong community development framework that helps you to strengthen
					the relationships between your members and engage more fully with the broader community.
					B2Me enables this by connecting service providers with people who are looking for a
					service.
				</p>

				<h2>In what ways does B2Me support our values as a faith community?</h2>
				<p>
					B2Me Australia is not a faith-based organisation, but our values reflect many of the
					values held by faith communities and the community at large.
				</p>

				<h2>What are the tangible benefits for our faith community in joining?</h2>
				<p>
					As B2Me continues to grow, a percentage of our profits will be invested back into the
					community by way of grants to support the activities of a whole range of local
					community-based groups.
				</p>

				<section>
					<div style={{display: 'flex', justifyContent: 'center'}}>
						<FancyLink
							className="calltoaction"
							href="https://share.hsforms.com/1IpKFZ73dRjyHzG9ZGQkoPw2gqzs">
							Request a demo
						</FancyLink>
						<FancyButton className="emphasis calltoaction" onClick={signup}>
							Get started
						</FancyButton>
					</div>
				</section>
			</section>
		</Page>
	);
};

const ConnectedFaithPage = connect(
	() => ({}),
	dispatch => ({
		signup: () => dispatch(uiActions.uiModal('signup'))
	})
)(FaithPage);

export default ConnectedFaithPage;



// WEBPACK FOOTER //
// ./src/pages/FaithPage.js